// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"955aa4e1","764":"f8fe9190","860":"7d6eec61"}[chunkId] + ".chunk.js";
};